import { getSnowplowEventPayload, logAnalyticsEvent } from '../../analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from '../../analytics.const';

import type { GalleryEvent } from './types';

const { VEHICLE_DETAILS } = ANALYTICS_CATEGORIES;

export const triggerHeroImageClickedEvent = ({ kind }: GalleryEvent): void => {
	const eventPayload = getSnowplowEventPayload({
		category: VEHICLE_DETAILS,
		customData: { label: kind },
		name: 'dlr_hero_image_clicked',
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
